import React from 'react';

import { SpinnerComponent } from 'design/spinner';
import { createPressControlClassName } from './pressControlStyles';

type PressControlTheme = 'primary' | 'accent' | 'critical' | 'google';

type SharedProps = {
  theme: PressControlTheme;
  disabled?: boolean;
  fill?: boolean;
  hasSpinner?: boolean;
  narrow?: boolean;
  hasIcon?: boolean;
};

type SubmitProps = SharedProps & {
  type: 'submit';
};

type ButtonProps = SharedProps & {
  type: 'button';
  onPress(): void;
};

type Props = ButtonProps | SubmitProps;

export const PressControlComponent: React.FC<Props> = (props) => {
  const {
    children,
    theme,
    disabled,
    fill,
    hasSpinner,
    hasIcon,
    narrow,
  } = props;

  const buttonClassName = createPressControlClassName('button', {
    theme,
    hasSpinner,
    fill,
    narrow,
    hasIcon,
  });

  const slotClassName = createPressControlClassName('slot', {
    theme,
    hasSpinner,
    fill,
    hasIcon,
  });

  const spinnerClassName = createPressControlClassName('spinner', {
    theme,
    hasSpinner,
    fill,
    hasIcon,
  });

  const handleClick = React.useCallback(
    (event: React.SyntheticEvent) => {
      if (props.type === 'button') {
        props.onPress();
        event.preventDefault();
      }
    },
    [props]
  );

  return (
    <button
      type={props.type}
      disabled={disabled}
      className={buttonClassName}
      onClick={handleClick}
    >
      <div className={slotClassName}>{children}</div>
      <div className={spinnerClassName}>
        <SpinnerComponent />
      </div>
    </button>
  );
};
